import type { DropdownGroupOptions } from "@/components/common/Dropdown/Dropdown.types";

export const PERIOD_KEYS = [
  "P_W",
  "P_M",
  "P_Q",
  "MV_1",
  "MV_2",
  "MV_4",
  "MV_8",
  "MV_12",
];

export const PERIOD_OPTIONS: DropdownGroupOptions[] = [
  {
    groupName: "Periodic",
    options: [
      { value: "P_W", label: "Weeks" },
      { value: "P_M", label: "Months" },
      { value: "P_Q", label: "Quarters" },
    ],
  },
  {
    groupName: "Moving Average",
    options: [
      { value: "MV_1", label: "1 Week" },
      { value: "MV_2", label: "2 Week" },
      { value: "MV_4", label: "4 Week" },
      { value: "MV_8", label: "8 Week" },
      { value: "MV_12", label: "12 Week" },
    ],
  },
];
